<section>
  <div class="container container-wrapper">
    <form ngForm name="contactForm">
      <div class="row">
        <div class="col-12">
          <h3 class="pb-3">{{ 'Contact Form' | translate }}</h3>
          <p class="pb-3">{{ 'Contact-message-email-phone'
            | translate:{companyEmail: companyEmail} }} {{ companyPhone }}
            <br>
            <br> {{ 'Maybe this will help you first:' | translate }}
            <a class="faq-link" (click)="onClickFAQ()">{{ 'FAQ’s' | translate }}</a>,
            {{'there is certainly one or the other question clarified in advance.' | translate }}
          </p>
        </div>
        <div class="col-md-6">
          <app-input [title]="'Name' | translate" [name]="'name'" [(ngModel)]="name" required minLength="2">
          </app-input>
        </div>
        <div class="col-md-6">
          <app-input [title]="'E-Mail Adresse' | translate" [name]="'email'" [(ngModel)]="email" email required>
          </app-input>
        </div>
        <div class="col-md-12">
          <app-textarea [name]="'message'" [title]="'Your message' | translate" [(ngModel)]="message" required>
          </app-textarea>
        </div>
        <div class="col-md-12">
          <app-checkbox
            [title]="'I hereby accept that my name, my e-mail address and the content of my message will be forwarded to the website operator via secure connection. My data will not be passed on to third or stored longer than necessary. I read the privacy policy.' | translate"
            [name]="'agreement'" [(ngModel)]="agreement" [textInTop]="true" required></app-checkbox>
        </div>
        <div class="col-md-4">
          <app-button [title]="'Send' | translate" (click)="onSend()"
            [buttonCssClass]="'button button-right button-black'" [disabled]="!isFormValid || formProcessing">
          </app-button>
        </div>
      </div>
    </form>
  </div>
</section>
